<template>
  <div>
    <p>{{ $t("GenerateCatalogFromTextFile.Intro.Part1") }}</p>
    <p>{{ $t("GenerateCatalogFromTextFile.Intro.Part2") }}</p>
    <p class="mb-0">
      {{
        $t("GenerateCatalogFromTextFile.Intro.Continue", {
          ButtonName: $t("Continue")
        })
      }}
    </p>
    <div class="catalog-modal-buttons">
      <b-btn
        @click="
          $emit('stepChange', {
            currentState: 'Intro',
            nextState: 'ExistingCatalog'
          })
        "
        >{{ $t("Continue") }}</b-btn
      >
    </div>
  </div>
</template>
